import {ContentHotel} from '@findhotel/sapi/dist/types/packages/core/src/types'
import {FAQs} from 'components/FAQs'
import {usePriceInsightsFAQ} from 'hooks/usePriceInsightsFAQ'

import {Box} from '@vio/atlas/src/components/designSystem/helpers/Box'
import {Text} from '@vio/atlas/src/components/designSystem/Text'
import {DatePickerVariant} from '@vio/core/src/datePicker/types'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

interface Props {
  variant: DatePickerVariant
  hotel: ContentHotel
}

export const ConditionalPriceInsightsFAQ = ({hotel, variant}: Props) => {
  const hotelId = hotel?.objectID
  const {faqs} = usePriceInsightsFAQ(hotelId)

  if (!faqs || !faqs.length) return null

  return (
    <Box
      data-id="priceInsightsFaq"
      paddingLeft={variant === 'vertical' ? 's500' : 's000'}
      paddingRight={variant === 'vertical' ? 's500' : 's000'}
      paddingBottom={variant === 'vertical' ? 's300' : 's000'}
      marginBottom={variant === 'horizontal' ? 's800' : 's600'}
      display="flex"
      flexDirection="column"
      gap={variant === 'horizontal' ? 's400' : 's500'}
    >
      <Text tag="h2" variant={variant === 'horizontal' ? 'titleXL' : 'titleL'}>
        <FormattedMessageWrapper
          id="priceInsightsFAQ.title"
          defaultMessage="Considering this hotel for your {city} trip?"
          values={{city: hotel.navPathInfo?.city?.name}}
        />
      </Text>
      <FAQs faqs={faqs} isMobile={variant === 'vertical'} />
    </Box>
  )
}
